import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AuthService} from "../../../../core/auth/auth.service";
import {Router} from "@angular/router";
import {StorageService} from "@portal/shared/services/storage.service";
import {CatalogProductsService} from "@portal/api/catalog-products.service";
import {CatalogProduct} from "@portal/api/contracts/catalog-products/catalog-product";

@Component({
    selector: 'app-product-catalog',
    templateUrl: './product-catalog.component.html',
    styleUrls: ['./product-catalog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ProductCatalogComponent implements OnInit {
    quoteSidebarOpen = false;

    products: any;
    quoteItems: any[] = [];
    cartShouldBounce = false;

    constructor(
        private authService: AuthService,
        private router: Router,
        private storageService: StorageService,
        private catalogProductsService: CatalogProductsService){
    }

    ngOnInit(): void {
        if (this.authService.isAuthenticated) {
            this.router.navigate(['/catalog']);
        }
        this.quoteItems = this.storageService.getQuoteItems();

        this.catalogProductsService.getCatalogs().subscribe( response => {
            if (response.data) {
                this.products = response.data;
                this.products.forEach((product: CatalogProduct) => {
                    product.quantity = 1;
                });
            }
        })
    }

    saveQuoteItems(): void {
        this.storageService.setQuoteItems(this.quoteItems);
    }

    toggleQuoteSidebar(): void {
        this.quoteSidebarOpen = !this.quoteSidebarOpen;
    }

    addToQuote(product: any): void {
        const existing = this.quoteItems.find(p => p.name === product.name);
        if (existing) {
            existing.quantity += product.quantity;
        } else {
            this.quoteItems.push({ ...product });
        }
        product.quantity = 1;
        this.saveQuoteItems();
    }

    removeItem(index: number): void {
        this.quoteItems.splice(index, 1);
        this.saveQuoteItems();
    }

    updateTotal(): void {
        this.saveQuoteItems();
    }

    getTotalQuantity(): number {
        return this.quoteItems.reduce((total, item) => total + item.quantity, 0);
    }

    selectedProduct: any = null;
    selectedImageIndex: number = 0;

    openGallery(product: any): void {
        this.selectedProduct = product;
        this.selectedImageIndex = 0;
    }

    closeGallery(): void {
        this.selectedProduct = null;
    }

    nextImage(): void {
        if (!this.selectedProduct) return;
        this.selectedImageIndex = (this.selectedImageIndex + 1) % this.selectedProduct.images.length;
    }

    prevImage(): void {
        if (!this.selectedProduct) return;
        this.selectedImageIndex =
            (this.selectedImageIndex - 1 + this.selectedProduct.images.length) % this.selectedProduct.images.length;
    }

    navigateToQuote(): void {
        const route = this.authService.isAuthenticated ? '/catalog/quote-request' : '/product-catalog/quote';
        this.router.navigate([route]);
    }

    isLoggedIn(): boolean {
        return this.authService.isAuthenticated;
    }

    handleAddToQuote(product: any): void {
        this.addToQuote(product);
        product.addedToQuote = true;
        this.cartShouldBounce = true;

        setTimeout(() => {
            product.addedToQuote = false;
        }, 1000); // tempo da animação
    }
}
